import styled from "styled-components";

export const StyledPropertyList = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  height: 100vh;
  gap: 20px;
  color: ${({ theme }) => theme.colors.text};
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-auto-rows: 400px;
    height: 100%;
    overflow-y: initial;
  }
  h4 {
    color: ${({ theme }) => theme.colors.text};
  }
`;

export const StyledPropertyCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 100%;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;

  h3 {
    font-size: 16px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.text};
    width: 100%;
    line-height: 1.2;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: initial;
  }
`;
export const StyledMainImage = styled.img`
  height: 400px;
  width: 100%;
  object-fit: cover;
  border-radius: 10px;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    height: 300px;
  }
`;

export const StyledTag = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 12px;
  background-color: ${({ theme }) => theme.colors.card};
  color: ${({ theme }) => theme.colors.text};
  padding: 4px 8px;
  border-radius: 10px;
  min-width: 40px;
  img {
    height: 16px;
    filter: ${({ theme }) =>
      theme.colors.background === "#171717" ? "invert(1)" : "invert(0)"};
  }
`;
